// extracted by mini-css-extract-plugin
export default {"container":"DropFiles_container__OXj-u","drag-active":"DropFiles_drag-active__VxyLu"};